"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _formatAbstractDate = _interopRequireDefault(require("../internal/utils/formatAbstractDate"));

var _default = function _default(value, type) {
  return (0, _formatAbstractDate.default)({
    value: value,
    type: type,
    format: 'QY',
    length: 's'
  });
};

exports.default = _default;
module.exports = exports.default;